// extracted by mini-css-extract-plugin
export default {"task_container":"task_task_container__Eu2S6","task_heading":"task_task_heading__rD1vb","task_complete":"task_task_complete__h1u1X"};